<template>
  <div class="blog-area ptb-100">
    <div class="container mw-1356">
      <div class="section-title m-auto text-center mw-860">
        <span class="top-title">مدونتنا</span>
        <h2>أحدث مقالاتنا حول عالم البث الرقمي</h2>
      </div>

      <div class="row">
        <div class="col-lg-9 order-2 order-lg-1">
          <div class="row justify-content-center">
            <div
              v-for="(blog, index) in paginatedBlogs"
              :key="index"
              class="col-xl-4 col-md-6"
            >
              <div class="blog-single-item transition-y">
                <RouterLink :to="blog.link" class="d-block blog-img">
                  <img :src="blog.image" :alt="blog.title" />
                </RouterLink>

                <div class="blog-content">
                  <RouterLink :to="blog.tagLink" class="tag">{{
                    blog.category
                  }}</RouterLink>
                  <h3>
                    <RouterLink :to="blog.link">{{ blog.title }}</RouterLink>
                  </h3>
                  <ul class="d-flex align-items-center flex-wrap ps-0 mb-0">
                    <li class="d-flex align-items-center">
                      <i class="ti ti-calendar-week"></i>
                      <span>{{ blog.date }}</span>
                    </li>
                    <li class="d-flex align-items-center">
                      <i class="ti ti-clock"></i>
                      <span>{{ blog.readTime }} دقيقة قراءة</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <div class="pagination-area text-center mt-4">
                <span
                  class="next page-numbers"
                  :class="{ disabled: currentPage === 1 }"
                  @click="prevPage"
                  style="cursor: pointer"
                >
                  <i class="ri-arrow-left-s-line"></i>
                </span>

                <span
                  v-for="page in totalPages"
                  :key="page"
                  class="page-numbers"
                  :class="{ current: currentPage === page }"
                  @click="goToPage(page)"
                  style="cursor: pointer"
                >
                  {{ page }}
                </span>

                <span
                  class="next page-numbers"
                  :class="{ disabled: currentPage === totalPages }"
                  @click="nextPage"
                  style="cursor: pointer"
                >
                  <i class="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3 order-1 order-lg-2 mb-5 mb-lg-0">
          <SidebarWidget />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import SidebarWidget from "../Blog/SidebarWidget.vue";

export default defineComponent({
  name: "BlogList",
  components: {
    SidebarWidget,
  },
  setup() {
    const blogs = ref([
      {
        image: require("@/assets/images/blog-4.jpg"),
        category: "تقنية",
        tagLink: "/tags",
        title: "كيف تجعل تجربة البث أكثر متعة؟",
        link: "/blog-details",
        date: "23 يناير، 2026",
        readTime: 5,
      },
      {
        image: require("@/assets/images/blog-2.jpg"),
        category: "معرفة",
        tagLink: "/tags",
        title: "أهمية الإنترنت المستقر في عالم البث",
        link: "/blog-details",
        date: "22 يناير، 2026",
        readTime: 3,
      },
      {
        image: require("@/assets/images/blog-3.jpg"),
        category: "تقنية",
        tagLink: "/tags",
        title: "أفضل 5 ميزات في اشتراكاتنا الحديثة",
        link: "/blog-details",
        date: "21 يناير، 2026",
        readTime: 2,
      },
      // يمكنك إضافة المزيد من المقالات هنا بنفس الهيكلية
    ]);

    const currentPage = ref(1);
    const itemsPerPage = ref(9);

    const totalPages = computed(() =>
      Math.ceil(blogs.value.length / itemsPerPage.value)
    );

    const paginatedBlogs = computed(() => {
      const start = (currentPage.value - 1) * itemsPerPage.value;
      const end = start + itemsPerPage.value;
      return blogs.value.slice(start, end);
    });

    const goToPage = (page: number) => {
      currentPage.value = page;
    };

    const nextPage = () => {
      if (currentPage.value < totalPages.value) currentPage.value++;
    };

    const prevPage = () => {
      if (currentPage.value > 1) currentPage.value--;
    };

    return {
      blogs,
      currentPage,
      paginatedBlogs,
      totalPages,
      goToPage,
      nextPage,
      prevPage,
    };
  },
});
</script>